import { render, staticRenderFns } from "./VideoPlay.vue?vue&type=template&id=7c6096f0&"
import script from "./VideoPlay.vue?vue&type=script&lang=js&"
export * from "./VideoPlay.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports